const fontSizeMap = {
    eyebrow400: 400,
    heading300: 300,
    heading400: 400,
    heading500: 500,
    heading600: 600,
    heading700: 700,
    heading800: 800,
    heading900: 900,
    heading1000: 1000,
    heading1100: 1100,
    paragraph400: 400,
    paragraph500: 500,
    paragraph600: 600,
};
const mobileHeadingSizeMap = {
    heading300: 300,
    heading400: 400,
    heading500: 500,
    heading600: 500,
    heading700: 600,
    heading800: 700,
    heading900: 800,
    heading1000: 900,
    heading1100: 1000,
};
const mapFontSize = (textStyle, theme) => theme.fontSizes[fontSizeMap[textStyle]];
const mapMobileHeadingFontSize = (textStyle, theme) => theme.fontSizes[mobileHeadingSizeMap[textStyle]];
const isMobileHeading = (textStyle) => textStyle in mobileHeadingSizeMap;

export { isMobileHeading, mapFontSize, mapMobileHeadingFontSize };
